// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1U5Ab","info":"PatientInfo_info__38mZ7"};